import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

// --- Shared "run in the background" confirmation (Design Assistant UX plan §9C): shown once the server has
// taken the run. Beneficial Ownership's dialog, moved here unchanged; each workflow passes its own wording.

export interface BackgroundRunDialogProps {
  open: boolean;
  title: string;
  body: React.ReactNode;
  /** Closing (the button, Escape, the backdrop) — the workflow usually resets to a fresh start here. */
  onClose: () => void;
}

const BackgroundRunDialog: React.FC<BackgroundRunDialogProps> = ({ open, title, body, onClose }) => (
  <Dialog
    className='dialog_box'
    open={open}
    onClose={onClose}
    maxWidth='sm'
    fullWidth
    PaperProps={{
      style: {
        backgroundColor: 'var(--bg-colors)',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        borderRadius: '0.5rem',
        maxWidth: '620px',
        width: '90%',
        margin: '0 auto',
      },
    }}
  >
    <DialogTitle className='modal-header-content modal-title'>{title}</DialogTitle>
    <DialogContent className='dialog-content-base'>
      <div className='audit-add-modal-cont-body' style={{ paddingTop: '12px', paddingBottom: '12px' }}>
        <p className='wizard-body-text' style={{ marginBottom: '20px' }}>
          {body}
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button className='btn-new-automate' type='button' onClick={onClose}>
            <div>Okay</div>
          </button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default BackgroundRunDialog;
